
//import Moment from 'moment'

function padLeftZero(str) {
	return ('00' + str).substr(str.length)
}
//专业名格式化显示，专业名后面第一个括号开始的后面使用暗色，前面使用亮色
function formatMajorName(str){
	let firstSplitPos = str.indexOf('(');
	if(firstSplitPos < 0)
		return '<span style="color:#409EFF">' + str + '</span>';
		
	let majorName = str.slice(0,firstSplitPos);
	let majorNameNote = str.slice(firstSplitPos);
	
	return '<span style="color:#409EFF;cursor: pointer;">' + majorName 
		+ '</span><span style="color:#909399; font-size:14px;">' + majorNameNote + '</span>';
}

export default{
	//生成随机数字
	getRndCode(len) {
		let tCode = '';
		//设置长度，这里看需求，我这里设置了4
		var codeLength = len;
		//设置随机字符
		var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
	
		//循环codeLength 我设置的4就是循环4次
		for (var i = 0; i < codeLength; i++) {
			//设置随机数范围,这设置为0 ~ 36
			var index = Math.floor(Math.random() * 9);
			//字符串拼接 将每次随机的字符 进行拼接
			tCode += random[index];
		}
		//将拼接好的字符串赋值给展示的code
		return tCode;
	},
	//格式化排名
	formatSchOrder(val){
	   if(!val)return "--";
	   if(val=='0')return "--";
	   if(val=='10000') return "--";
	   return val;
	},
	//转换选科名字的显示，如 物理->物
	getSbjShortName(stuSbjs) {
		if (stuSbjs == undefined || stuSbjs.length == 0) return stuSbjs;
		let shortSbj = stuSbjs.replace('语文','语').replace('数学','数').replace('外语','外')
					.replace('物理','物').replace('化学','化').replace('生物','生')
					.replace('历史','史').replace('地理','地').replace('政治','政').replace(/[文理]综/,'综');
		return shortSbj;
	},
	//转换选科
	getSubjectShortText(sbj) {
		if (typeof(sbj) == "string" && sbj.length > 0) {
			let temp = sbj.replace("W", "物").replace("H", "化").replace("S", "生").replace("L", "史")
				.replace("Z", "政").replace("D", "地").replace("J", "技");
			return temp;
		}
	},
	//转换选科
	getSubjectText(sbj) {
		if (typeof(sbj) == "string" && sbj.length > 0) {
			sbj = sbj.toLocaleUpperCase();
			let temp = sbj.replace("W", "物理、").replace("H", "化学、").replace("S", "生物、").replace("L", "历史、")
				.replace("Z", "政治、").replace("D", "地理、").replace("J", "技术、").replace("X", "不限、");
			let temp2 = temp.substring(0, temp.length - 1);
			return temp2;
		}
	},
	//转换学生的选科
	getStuSbjText(sbj, wlTypeName){
		if (typeof (sbj) == "string" && sbj.length > 0) {
			let temp = sbj.replace("W", "物理，").replace("H", "化学，").replace("S", "生物，").replace("L", "历史，")
				.replace("Z", "政治，").replace("D", "地理，").replace("J", "技术，").replace("w", "物理，").replace(
					"h", "化学，").replace("s", "生物，").replace("l", "历史，")
				.replace("z", "政治，").replace("d", "地理，").replace("j", "技术，");
			let temp2 = temp.substring(0, temp.length - 1);
			return temp2;
		} else {
			return wlTypeName;
		}
	},
	
	//判断院校名称中是否含有招考类型的名字
	FormatZkTypeStr(schname, typename) {
		if (schname == undefined || schname == '') return typename;
		var index = schname.indexOf(typename);
		if (index < 0) {
			return typename;
		} else return '';
	},
	// 将秒数转化为分钟：秒的时间格式
	toTime(sec) {
		//秒数转化为mm:ss形式
		let s = sec % 60 < 10 ? "0" + (sec % 60) : sec % 60;
		let min =
			Math.floor(sec / 60) < 10 ?
			"0" + Math.floor(sec / 60) :
			Math.floor(sec / 60);
		return min + ":" + s;
	},
	toTime2(sec){
		//秒数转化为mm:ss形式
		let s = sec % 60 < 10 ? "0" + (sec % 60) : sec % 60;
		let min = Math.floor(sec % 3600 / 60);
		let minstr = "";
		if (min < 10) minstr = "0" + min;
		else minstr = min + "";
		let hour = Math.floor(sec / 3600);
	
		if (hour > 0)
			return hour + ":" + minstr + ":" + s;
		else {
			return minstr + ":" + s;
		}
	},
	
	// 将时间格式转化为 指定的格式 如“yyyy-MM-dd”
	dateFormat(date, fmt) {
		if (!date) return "";
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
		}
		let o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'h+': date.getHours(),
			'm+': date.getMinutes(),
			's+': date.getSeconds()
		}
		for (let k in o) {
			if (new RegExp(`(${k})`).test(fmt)) {
				let str = o[k] + ''
				fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
			}
		}
		return fmt
	},
	dateShortCuts() {
		let s = [{
				text: "今天",
				value: () => {
					const end = new Date();
					const start = new Date();
					//start.setTime(end.getTime() - 3600 * 1000 * 24);
					return [start, end];
				},
			},
			{
				text: "近两天",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
					return [start, end];
				},
			},
			{
				text: "近三天",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(end.getTime() - 3600 * 1000 * 24 * 2);
					return [start, end];
				},
			},
			{
				text: "近一周",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
					return [start, end];
				},
			},
			{
				text: "近一月",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(end.getTime() - 3600 * 1000 * 24 * 30);
					return [start, end];
				},
			},
			{
				text: "本月",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setDate(1);
					return [start, end];
				},
			},
			{
				text: "上月",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setDate(1);
					start.setMonth(start.getMonth() - 1);
					end.setDate(1);
					let timestart = end.getTime();
					end.setTime(timestart - 3600 * 1000 * 24);
					return [start, end];
				},
			},
		];
		return s;
	},
	getRandomCode(len) {
		let str = "1234567890abcdefghijkmnpqrstuvwxyz";
		let l = str.length;
		let aim = "";
		if (!isNaN(len)) len = 4;
		while (aim.length < len) {
			let index = Math.floor((Math.random() * l));
			aim += str[index];
		}
		return aim;
	},
	
	// 格式化时间同年不显示年，不显示秒
	SxtFormatDate(dateStr) {
		if (!dateStr) return "";
		let resStr = "";
		let m1 = new Date(dateStr);
		let m2 = new Date();
		
		let resStrYear = '';
		if (m1.getFullYear() != m2.getFullYear()) {
			resStrYear = m1.getFullYear() + "-";
		}
		let resStrMonth = ((m1.getMonth() + 1) < 10 ? "0" : "") + (m1.getMonth() + 1);
		let resStrDay = "-" + (m1.getDate() < 10 ? "0" : "") + m1.getDate();
		let resStrHours = " " + (m1.getHours() < 10 ? "0" + m1.getHours() : m1.getHours());
		let resStrMinutes = ":" + (m1.getMinutes() < 10 ? "0" + m1.getMinutes() : m1.getMinutes());
		resStr = resStrYear + resStrMonth + resStrDay + resStrHours + resStrMinutes;
		
		return resStr;
	},
	// 判断给定的时间串是否是 过去的 日期 （注意是日期，而不是时间）
	isPastDay(datstr) {
		if (!datstr) return true;
		let date1 = new Date(datstr);
		let date2 = new Date()
		date2.setHours(23);
		date2.setMinutes(59);
		date2.setSeconds(59);
		return date1 < date2;
	},
	// 判断给定的两个时间串的时间大小关系 -1 表小于 0表 相等  1表 大于
	compareDate(datstr1, date2str) {
		let date1 = new Date(datstr1);
		let date2 = new Date(date2str);
		if (date1.getTime() == date2.getTime()) return 0;
		if (date1.getTime() < date2.getTime()) return -1;
		return 1;
	},
	log(str) {
		if (process.env.NODE_ENV == 'development') {
			console.log(str);
		}
	},
	//替换成高亮文本
	highlight(str, keys) {
		if (keys == undefined || keys.length == 0) return str;
		for (var i = 0; i < keys.length; i++) {
			let element = keys[i];
			if (str.indexOf(element) != -1) {
				str = str.replace(element, "<span style='color:#E6A23C;'>" + element + "</span>");
				//break;
			}
		}
		return str;
	},
	//高亮名称中关键字
	highLightKeyWord(str, pkeys) {
		console.log('pkeys',pkeys);
		if (pkeys == undefined || pkeys.length == 0) return str;
		if (str == undefined) {
			return "";
		}
	
		let keys = pkeys.split(',');
		//console.log('keys',keys);
		//let keys = ['地方专项', '高校专项', '八省协作', '八协计划', '八省区对等协作计划'];
		for (var i = 0; i < keys.length; i++) {
			let element = keys[i];
			if (str.indexOf(element) != -1) {
				str = str.replace(eval('/' + element + '/g'),
					"<span style='color:red;cursor: pointer;font-size:1.1em;' title='名称包含特殊关键字，请谨慎选择！！'>" +
					element + "</span>");
				continue;
			}
		}
		return str;
	},
	//高亮院校名称中关键字
	highLightSchName(str, pkeys) {
		//console.log('pkeys',pkeys);
		if (pkeys == undefined || pkeys.length == 0) return str;
		if (str == undefined) {
			return "";
		}
	
		let keys = pkeys.split(',');
		//console.log('keys',keys);
		//let keys = ['地方专项', '高校专项', '八省协作', '八协计划', '八省区对等协作计划'];
		for (var i = 0; i < keys.length; i++) {
			let element = keys[i];
			if (str.indexOf(element) != -1) {
				str = str.replace(eval('/' + element + '/g'),
					"<span style='color:red;cursor: pointer;font-size:1.1em;' title='名称包含特殊关键字，请谨慎选择！！'>" +
					element + "</span>");
				continue;
			}
		}
		return str;
	},
	//高亮专业名称中关键字
	highLightMajorName(str, pkeys) {
		str = formatMajorName(str);
		
		//console.log('pkeys',pkeys);
		if (pkeys == undefined || pkeys.length == 0) return str;
		if (str == undefined) {
			return "";
		}
	
		let keys = pkeys.split(',');
		//console.log('keys',keys);
		//let keys = ['蒙语授课', '只招', '不招收', '面向', '走读', '保送生', '民族班', '高校专项', '高水平', '定向', '(口)'];
		if (keys == undefined || keys.length == 0) return str;
		for (var i = 0; i < keys.length; i++) {
			let element = keys[i];
			if (str.indexOf(element) != -1) {
				str = str.replace(eval('/' + element + '/g'),
					"<span style='color:red;cursor: pointer;font-size:1.1em;' title='名称包含特殊关键字，请谨慎选择！！'>" +
					element + "</span>");
				continue;
			}
		}
		return str;
	},
	//对象的 排序 方法
	//key 数组对象的属性名，isAsc 是否是升序
	//使用：arr.sort(sortExp('price',true));
	sortExp(key, isAsc) {
		return function(x, y) {
			if (isNaN(key)) {
				if (x[key] > y[key]) {
					return 1 * (isAsc ? 1 : -1);
	
				} else if (x[key] < y[key]) {
					return -1 * (isAsc ? 1 : -1);
				} else {
					return 0;
				}
			} else {
				return (x[key] - y[key]) * (isAsc ? 1 : -1)
			}
		}
	},
	ShowDiffScore(archiveX, schAreaID, canKaoScore) {
		if (!archiveX) return;
		//schAreaID：院校所在地，canKaoScore：院校或专业的参考分数
		let dxscore = 0; //考生等效分
		if (archiveX.CS > 0 || archiveX.PS > 0) {
			if (archiveX.AreaID == schAreaID) {
				dxscore = archiveX.PS;
			} else {
				dxscore = archiveX.CS;
			}
		} else {
			dxscore = archiveX.Score; //等效分
		}
		//返回参考分与考生等效分的分差
		let diffScore = canKaoScore - dxscore;
		return diffScore > 0 ? '+' + diffScore : diffScore;
	},
	GetCWBColor(diffScore) {
		// debugger;
		//和考生分差，正数表示比考生分高，负数表示比考生分低
		//sp-stu >= 0 冲
		//-10 <= sp-stu < 0 稳
		//sp-stu < -10 保
		//学生等效分-参考分数 <= 0 为冲(红色)； 0 < 学生等效分-参考分数 <= 10 为稳(黄色)；学生等效分-参考分数 > 10 为保(绿色)；
		if (diffScore >= 0) {
			return "hong";
		} else if (diffScore >= -10 && diffScore < 0) {
			return "huang";
		} else {
			return "lv";
		}
	},
	//根据专业的预估排名计算相应的相似排名，用于排序
	//预估排名在1.5%之内，认为排名相同（相似排名）
	CalcMajorPlanSameOrder1(majorPlanList) {
		let sameOrderRate = 1.015;
		//先排序
		majorPlanList.sort((a, b) => {
			return a.RefOrder - b.RefOrder; //升序
		});
		let curntSameOrderEnd = 0;
		let curntSameOrderStart = 0;
		majorPlanList.forEach((item, indx) => {
			if (indx == 0) {
				curntSameOrderStart = item.RefOrder;
				curntSameOrderEnd = item.RefOrder * sameOrderRate;
			}
			if (item.RefOrder <= curntSameOrderEnd) {
				item.SameOrder = curntSameOrderStart;
			} else {
				curntSameOrderStart = item.RefOrder;
				curntSameOrderEnd = item.RefOrder * sameOrderRate;
				item.SameOrder = curntSameOrderStart;
			}
		});
		return majorPlanList;
	},
	//预估排名在1.5%之内，认为排名相同（相似排名）
	CalcMajorPlanSameOrder2(majorPlanList) {
		let defSameOrderRate = 1.015;
		//先排序
		majorPlanList.sort((a, b) => {
			return a.MajorPlanModel.RefOrder - b.MajorPlanModel.RefOrder; //升序
		});
		let curntSameOrderEnd = 0;
		let curntSameOrderStart = 0;
	
		majorPlanList.forEach((item, index) => {
			if (index == 0) {
				curntSameOrderStart = item.MajorPlanModel.RefOrder;
				curntSameOrderEnd = item.MajorPlanModel.RefOrder * defSameOrderRate;
			}
			if (item.RefOrder <= curntSameOrderEnd) {
				item.MajorPlanModel.SameOrder = curntSameOrderStart;
			} else {
				curntSameOrderStart = item.MajorPlanModel.RefOrder;
				curntSameOrderEnd = item.MajorPlanModel.RefOrder * defSameOrderRate;
				item.MajorPlanModel.SameOrder = curntSameOrderStart;
			}
		});
		return majorPlanList;
	},
	//转换专业等级为数值，用于排序
	GetRanking(rankText) {
		if (rankText != '') {
			return rankText.replace('A+', '4').replace('A', '3').replace('B+', '2').replace('B', '1').replace('','0');
		}
		return '';
	},
	//转换专业等级为文本
	GetRankText(rank) {
		if (rank != '') {
			return rank.replace('4', 'A+').replace('3', 'A').replace('2', 'B+').replace('1', 'B').replace('0', '');
		}
		return '';
	},
	//转换排名
	GetGradeText(grade) {
		if (grade != '') {
			return grade;
		}
		return '';
	},
	CuttingBoard(value,callback) {
		let _this_ = this;
		// navigator.clipboard.writeText(_this_.fuzhi);
	
		var textArea = document.createElement("textarea");
		textArea.value = value;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
	
		try {
			var successful = document.execCommand('copy');
			var msg = successful ? '成功' : '失败';
			callback("已复制到剪切板，请粘贴到电子表格中",1);
		} catch (err) {
			callback("失败",0);
		}
		document.body.removeChild(textArea);
	},
	//返回与往年计划的人数差
	//参数：模版名称，计划年份，当前计划招生数，三年分数，新增院校或新增专业
	GetDiffPlanCount(mobanname,planyear,curplancount,strscoreinfo,newplan,wltype){
		//return strhtml += '<span title="与上一年相比增加 0 人">+0</span><br>';
		//debugger;
		var strhtml = '<span>'+curplancount+'</span><br>';
		let diffcount = 0;
		//let jsonArray = JSON.parse(strscoreinfo);
		let jsonArray = strscoreinfo;
		//console.log('jsonArray',jsonArray);
		
		if(mobanname.includes('模拟')){
			planyear = planyear - 1;
		}
		let hisplancount = 0;
		let hisplan = jsonArray.find(item=>item.Year == (planyear-1) && item.WLType == wltype);
		
		if(hisplan != undefined){
			if("PlanCount" in hisplan){
				hisplancount = hisplan.PlanCount;
			}
			if(hisplancount!=''){
				diffcount = curplancount - hisplancount;
			}
			if(diffcount>0){
				strhtml += '<span title="与上一年相比增加 '+diffcount+' 人" style="color:#67c23a;">+'+diffcount+'</span><br>';
			}else if(diffcount<0){
				strhtml += '<span title="与上一年相比减少 '+-diffcount+' 人" style="color:#f56c6c;">'+diffcount+'</span><br>';
			}else{
				if(newplan == 0){//只有非新增院校或新增专业时才显示+0
					strhtml += '<span title="与上一年相比增加 0 人">+0</span><br>';
				}
			}
		}
		return strhtml;
	},
	//格式化排名
	formatOrder(val){
	   if(!val)return "--";
	   if(val=='0')return "--";
	   if(val=='10000') return "--";
	   if(val=='100/100') return "--";
	   return val;
	},
	//院校分数来源，不展示匹配关系和匹配说明
	getSchoolDataSource(item){
		var result = '<div>';
		if(item.S && item.LScore){
			result +='<div>';
			result += '<span style="color:#B0D0FF;">分数来源：</span>'+this.getScoreSourceColor(item);
			result +='</div>';
		}
		if(item.N && item.LScore){
			result +='<div>';
			result += '<span style="color:#B0D0FF;">往年院校：</span><span style="color:#FFFFFF;font-size:14px;">'+item.N+'</span>';
			result +='</div>';
		}
		result += '</div>'
		return result;
	},
	//专业分数来源
	getMajorDataSource(item){
		var result = '<div>';
		if(item.S && item.LScore){
			result += '<div><span style="color:#B0D0FF;">分数来源：</span>'+this.getScoreSourceColor(item)+'</div>';
			result += '<div><span style="color:#B0D0FF;">往年专业：</span><span style="color:#FFFFFF;font-size:14px;">'+item.N+'</span></div>';
			if(item.T){
				result += '<div><span style="color:#B0D0FF;">匹配关系：</span><span style="color:#FFFFFF;font-size:14px;">'+item.T+'</span></div>';
				result += '<div><span style="color:#B0D0FF;">匹配说明：</span><span style="color:#FFFFFF;font-size:14px;">'+this.GetScoreRemark(item.T)+'</span></div>';
			}
		}
		result += '</div>'
		return result;
	},
	getScoreSourceColor(item){
		var result = '';
		if(item.S && item.LScore){
			if(item.S.indexOf('官网')>-1){
				result = '<span style="color:#67c23a;font-size:14px;">'+item.S+'</span>';
			}else if(item.S.indexOf('投档线')>-1){
				result = '<span style="color:#ffaa7f;font-size:14px;">'+item.S+'</span>';
			}else if(item.S.indexOf('专家预估')>-1){
				result = '<span style="color:#faa590;font-size:14px;">'+item.S+'</span>';
			}else if(item.S.indexOf('专家调整')>-1){
				result = '<span style="color:#c68462;font-size:14px;">'+item.S+'</span>';
			}else{
				result = '<span style="color:#FFFFFF ; font-size:14px;">'+item.S+'</span>';
			} 
		}
		return result;
	},
	//专业分数来源
	getMajorDataSource1(item){
		var result = "";
		if(item.S && item.LScore){
			result = "分数来源："+item.S+"\r\n往年专业："+item.N;
			if(item.T){
				result += "\r\n匹配关系："+item.T+"\r\n匹配说明："+this.GetScoreRemark(item.T);
			}
		}
		return result;
	},
	//专业分数匹配说明
	GetScoreRemark(matchType){
		var remark = "";
		switch(matchType){
			case "包含一对多":
				remark = "专业名不同，但有包含专业，计划有一个、分数有多个";
				break;
			case "包含一对一":	
				remark = "专业名不同，但有包含专业，计划、分数均有一个";
				break;
			case "包含多对多":
				remark = "专业名不同，但有包含专业，计划、分数均有多个";
				break;
			case "包含多对一":
				remark = "专业名不同，但有包含专业，计划有多个、分数有一个";
				break;
			case "名称多对多":
				remark = "专业名相同，计划、分数均有多个";
				break;
			case "名称多对一":
				remark = "专业名相同，计划有多个、分数有一个";
				break;
			case "名称一对多":
				remark = "专业名相同，计划有一个、分数有多个";
				break;
			case "名称一对一":
				remark = "专业名相同，计划、分数均有一个";
				break;
			case "手工绑定":
				remark = "";
				break;
			default:
			remark = matchType;			
		}
		return remark;
	},
	//志愿草表信息提醒：提供给Admin志愿草表和Student志愿草表调用,学生端志愿草表openDt传null
	//IsTianBaoTime:是否是填报期间
	//conGKYear:ConsoleDesk.GKYear
	//stuGKYear:考生年份
	//IsGaoKao:高考方案传1，模考方案传0
	//IsLastMoBan:是否是最新模版
	//fanganTime:方案申请时间
	//openDt:方案开放时间
	CheckFangAnDetail(IsTianBaoTime,conGKYear,stuGKYear,IsGaoKao,IsLastMoBan,fanganTime,openDt){
		//返回1：弹窗提醒报考数据不完整
		if(!this.IsFullGKData(IsTianBaoTime,conGKYear,stuGKYear,IsGaoKao)){
			return '1';
		}
		//返回5：填报期间&数据完整后&模考方案,禁止修改方案
		if(!this.IsCheckDisable(IsTianBaoTime,conGKYear,stuGKYear,IsGaoKao)){
			return '5';
		}
		//返回2：弹窗提醒不是最新模版，备份并更新最新模版
		if(!this.IsLastNewMoBan(IsTianBaoTime,fanganTime,stuGKYear,IsGaoKao,IsLastMoBan,openDt)){
			return '2';
		}
		//返回4：提醒切换到高考方案,不提醒更换模版
		if(!this.IsGoGKFangAn(IsTianBaoTime,stuGKYear,IsGaoKao,IsLastMoBan,fanganTime,openDt)){
			return '4';
		}
		//返回3：需要检查分数与排名是否符合一分一段
		if(!this.IsCheckScoreOrder(IsTianBaoTime,IsGaoKao,fanganTime,stuGKYear)){
			return '3';
		}
		//返回0：可以正常做高考方案
		return '0';
		
	},
	//填报期间&高考方案&报考数据不完整,提醒不能做高考方案
	IsFullGKData(IsTianBaoTime,ConGKYear,stuGKYear,IsGaoKao){
		//IsTianBaoTime：是否为填报期间
		//ConGKYear：ConsoleDesk.GKYear 数据完整时这个GKYear会变成当年高考年份
		//stuGKYear：Studnet.GKYear 考生高考年份
		var flag = true;
		if(IsTianBaoTime && IsGaoKao == 1 && ConGKYear !=  stuGKYear){
			flag = false;
		}
		return flag;
	},
	//1.填报期间&当年高考方案
	//2.填报期间&模考方案&未发送
	//3.非填报期间：模考方案
	//满足以上3个条件其中一个，就提醒使用的不是最新计划，更换模版并备份
	IsLastNewMoBan(IsTianBaoTime,fanganTime,stuGKYear,IsGaoKao,IsLastMoBan,OpenDt){
		var flag = true;
		if((!IsTianBaoTime && IsGaoKao ==0 
		|| IsTianBaoTime && IsGaoKao ==1 && this.GetYearWithDateObject(fanganTime) >= stuGKYear
		|| IsTianBaoTime && IsGaoKao == 0 && OpenDt == null) 
		&& !IsLastMoBan){
			//不是最新模版，需弹窗提醒变更模版并备份方案
			flag = false;
		}
		return flag;
	},
	//填报期间&模考方案&已发送,仅仅提醒切换到高考方案,不提醒更换模版
	IsGoGKFangAn(IsTianBaoTime,stuGKYear,IsGaoKao,IsLastMoBan,fanganTime,OpenDt){
		var flag = true;
		if(IsTianBaoTime && IsGaoKao == 0 && OpenDt != null){
			flag = false;
		}
		return flag;
	},
	//填报期间&当年高考方案，检查排名分数是否符合
	IsCheckScoreOrder(IsTianBaoTime,IsGaoKao,fanganTime,stuGKYear){
		var flag = true;
		if(IsTianBaoTime && IsGaoKao==1 && this.GetYearWithDateObject(fanganTime) >= stuGKYear){
			flag = false;
		}
		return flag;
	},
	IsCheckDisable(IsTianBaoTime,ConGKYear,stuGKYear,IsGaoKao){
		var flag = true;
		if(IsTianBaoTime && ConGKYear == stuGKYear && IsGaoKao == 0){
			flag = false;//不能修改方案
		}
		return flag;
	},
	// 使用Date对象获取年份
	GetYearWithDateObject(dateString) {
	    // 创建Date对象
	    const date = new Date(dateString);	    
	    // 验证日期有效性
	    if (isNaN(date.getTime())) {
	        throw new Error('Invalid date format');
	    }
	    // 获取四位数的年份
	    return date.getFullYear();
	},
	//获取ConsoleDesk
	GetConsoleDesk(http,areaId){		
		http.get("ConsoleDesk/GetModel", {
			areaID: areaId
		}, false).then((res) => {
			return res;

		});
	}
}